<template>
  <div
    class="
      ring-2
      ring-custom-purple-500
      rounded-full
      flex
      text-center text-lg
      justify-center
      items-center
      shadow-md
      cursor-pointer
      text-custom-purple-500
      hover:bg-custom-purple-300
      hover:text-white
      hover:ring-0
      font-bold
    "
    :class="[sizeClass, borderClass]"
    :title="fullName"
  >
    <span class="text-center">{{ initials }}</span>
  </div>
</template>

<script>
export default {
  props: {
    user: {
      type: Object,
    },
    size: {
      type: Number,
      default: 10,
    },
    borderColor: {
      type: String,
      default: "gray-400",
    },
  },
  computed: {
    initials() {
      if (!this.user || !this.user.firstName || !this.user.lastName) {
        return "";
      }
      if (!this.user.firstName) {
        return this.user.lastName.charAt(0);
      }
      if (!this.user.lastName) {
        return this.user.firstName.charAt(0);
      }
      return (
        this.user.firstName.charAt(0).toUpperCase() +
        this.user.lastName.charAt(0).toUpperCase()
      );
    },
    fullName() {
      if (!this.user) {
        return "";
      }
      return `${this.user.firstName} ${this.user.lastName}`

    },
    sizeClass() {
      return `w-${this.size} h-${this.size}`;
    },
    borderClass() {
      return `border-${this.borderColor}`;
    },
  },
};
</script>
